import React, { useState, memo, useEffect } from 'react'
import { Trans } from 'react-i18next'
import { Image, Header, Grid } from 'semantic-ui-react'
import { SHADOW } from '../../colors'
import { IconX } from '../Icons'
import graphicCookie from './graphic-cookie-notice.svg'

const noticeStyle = {
  position: 'fixed',
  bottom: 0,
  zIndex: 10,
  height: 'fit-content',
  width: '100%',
  boxShadow: SHADOW
}

const iconStyle = {
  position: 'relative',
  top: '5px'
}

const MyLink = props => (
  <a href={props.href}>{props.children}</a>
)

const CookieNotice = () => {
  const [hidden, setIsHidden] = useState(false)

  const today = new Date()
  const lastNoticeDate = window.localStorage.getItem('cookieNotice')

  useEffect(() => {
    if (lastNoticeDate) {
      const sixMonthsAgo = new Date().setMonth(today.getMonth() - 6)
      if (sixMonthsAgo > new Date(lastNoticeDate)) {
        setIsHidden(false)
      } else {
        setIsHidden(true)
      }
    }
  }, [])

  const onClose = () => {
    setIsHidden(true)
    window.localStorage.setItem('cookieNotice', today)
  }

  return (
    <>
      {!hidden &&
        (
          <div style={noticeStyle}>
            <Grid style={{ width: '100%', margin: 0 }}>
              <Grid.Row columns={3}>
                <Grid.Column width={3} only='tablet computer'>
                  <Image src={graphicCookie} />
                </Grid.Column>
                <Grid.Column width={10} mobile={10} style={{ color: 'white' }}>
                  <Header><Trans i18nKey='cookie.notice.header'>Sphero Central Cookie Notice</Trans></Header>
                  <p>
                    <Trans
                      i18nKey='cookie.notice.description'
                      components={{ 1: <MyLink href='https://sphero.com/pages/privacy'>Privacy Policy</MyLink> }}
                    >
                      Sphero Central does not use any cookies for marketing, tracking, or analytics purposes. Sphero Central uses strictly necessary cookies required for core functionality, including site navigation and sign in. To learn more, please review our <MyLink href='https://sphero.com/pages/privacy'>Privacy Policy</MyLink>.
                    </Trans>
                  </p>
                </Grid.Column>
                <Grid.Column width={1}>
                  <IconX onClick={() => onClose()} style={iconStyle} />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </div>)}
    </>
  )
}

export default memo(CookieNotice)
